import { User } from '@idea2app/ai-work-order-service';
import { ClickBoundary, Icon } from 'idea-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Component } from 'react';
import { Image, ListGroup } from 'react-bootstrap';

import userStore from '../model/User';

@observer
export class UserMenu extends Component<User> {
    @observable
    accessor open = false;

    renderMenu = () => (
        <ListGroup className="position-absolute start-0 top-100">
            <ListGroup.Item action onClick={() => userStore.signOut()}>
                退出
            </ListGroup.Item>
        </ListGroup>
    );

    renderButton() {
        const { avatar, name } = this.props;

        return (
            <button
                className="border-0 bg-transparent d-flex align-items-center gap-2"
                style={{ appearance: 'none' }}
                onClick={() => (this.open = !this.open)}
            >
                {avatar ? (
                    <Image
                        style={{ width: '2rem', height: '2rem' }}
                        src={avatar}
                        alt={name}
                        roundedCircle
                    />
                ) : (
                    <Icon name="person-circle" size={2} />
                )}
                <span>{name}</span>
            </button>
        );
    }

    render() {
        return (
            <ClickBoundary
                className="position-relative"
                onOuterClick={() => (this.open = false)}
            >
                {this.renderButton()}
                {this.open && this.renderMenu()}
            </ClickBoundary>
        );
    }
}
